<template>
    <div
        :class="[
            'flex flex-col justify-center items-center gap-5',
            { 'fullscreen-loader': props.fullscreen, 'opaque-loader': props.opaque }
        ]"
    >
        <template v-if="props.progress == null">
            <div
                :class="[
                    'border-solid animate-spin rounded-full border-4 border-transparent h-16 w-16',
                    { 'border-t-white': props.fullscreen, 'border-t-card-500': !props.fullscreen }
                ]"
            ></div>
            <span
                :class="[
                    'font-medium text-xl',
                    { 'text-white': props.fullscreen, 'text-card-500': !props.fullscreen }
                ]"
            >
                <slot></slot>
            </span>
        </template>
        <template v-else>
            <div class="flex flex-col items-center gap-3 w-full max-w-md px-6">
                <span
                    :class="[
                        'font-medium text-xl',
                        { 'text-white': props.fullscreen, 'text-card-500': !props.fullscreen }
                    ]"
                >
                    <slot></slot>
                </span>
                <div
                    :class="[
                        'w-full h-3 rounded-full overflow-hidden',
                        props.fullscreen ? 'bg-white/20' : 'bg-card-200'
                    ]"
                >
                    <div
                        class="h-full rounded-full transition-all duration-300 ease-out"
                        :class="props.fullscreen ? 'bg-white' : 'bg-card-500'"
                        :style="{ width: `${clampedProgress}%` }"
                    ></div>
                </div>
                <span
                    :class="[
                        'font-semibold text-sm tabular-nums',
                        { 'text-white': props.fullscreen, 'text-card-500': !props.fullscreen }
                    ]"
                >
                    {{ Math.round(clampedProgress) }}%
                </span>
                <p
                    v-if="props.subMessage"
                    :class="[
                        'text-center text-sm mt-2 leading-relaxed',
                        { 'text-white/80': props.fullscreen, 'text-card-400': !props.fullscreen }
                    ]"
                >
                    {{ props.subMessage }}
                </p>
            </div>
        </template>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    fullscreen: {
        type: Boolean,
        default: false
    },
    opaque: {
        type: Boolean,
        default: false
    },
    progress: {
        type: Number,
        default: null
    },
    subMessage: {
        type: String,
        default: ''
    }
});

const clampedProgress = computed(() => Math.min(100, Math.max(0, props.progress ?? 0)));
</script>

<style scoped>
.fullscreen-loader {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.75);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
}

.opaque-loader {
    background-color: #40475b !important;
}
</style>
